import React, { useEffect } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import Category from "../pages/Category.jsx";
import Main from "../content/Main.jsx";
import Login from "../components/AC-LoginBox/Login.jsx";
import Search from "../components/AC-Search/Search";
import Async from "react-code-splitting";
import { handleMobileOrDesktop } from "../redux/actions/mainActions.js";
//  import WishList from "../components/AC-WishList/WishListItem";
// import CompareItems from "../components/AC-Compare/CompareItems.jsx";
import ProductPage from "../components/AC-ProductPage/ProductPage";
// import Messaging from "../components/AC-Messaging/Messaging.jsx";
import {
  categoryUnmountAction,
  categoryFetchFlagAction
} from "../redux/actions/menuActions";

/* import PromotionComponent from "../components/AC-Advertising/PromotionComponent"; */
/* import WishListMobile from "../components/AC-WishList/components/WishListMobile"; */
import Footer from "../components/AC-Footer/Footer";
import StaticContent from "../components/AC-StaticPages/StaticContent";

const MenuTopBarCat = () => <Async load={import("./MenuTopBarCat.jsx")} />;
/* const NavMenu = () => <Async load={import("./NavMenu.jsx")} />; */
/* const Compare = () => <Async load={import("./Compare.jsx")} />; */

export default function MenuCore(props) {
  const { component } = props;

  const dispatch = useDispatch();

  const [currentScreenWidth, setCurrentScreenWidth] = React.useState(
    window.innerWidth
  );

  React.useEffect(() => {
    const handleResize = () => {
      setCurrentScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  React.useEffect(() => {
    if (component !== "stores") {
      dispatch(categoryFetchFlagAction(true));
    }
  }, [component]);

  let isMobile;
  const mobileSize = 768;
  useEffect(() => {
    if (currentScreenWidth > mobileSize) {
      isMobile = false;
    } else {
      isMobile = true;
    }
    dispatch(handleMobileOrDesktop({ isMobile, currentScreenWidth }));
  }, [currentScreenWidth]);

  const handleWhatComponentToShowHere = () => {
    if (component === "category") {
      return <Category />;
    } else if (component === "product") {
      return <ProductPage />;
    } else if (component === "login") {
      return <Login />;
    } /*  else if (component === "aboutcomponent") {
      return <AboutComponent />;
    }  */ else if (component === "search") {
      return <Search />;
    } /* else if (component === "wishlist") {
      return <WishList />;
    } else if (component === "compareitems") {
      return <CompareItems />;
    } else if (component === "cookiepage") {
      return <CookiePage />;
    } else if (component === "messages") {
      return <Messaging />;
    } */ else if (component === "staticContent") {
      return <StaticContent />;
    } else {
      return <Main component={component} />;
    }
  };

  return (
    <React.Fragment>
      <div className="header-container">
        <MenuTopBarCat />
        {/*      <PromotionComponent /> */}
        {/*   <Compare /> */}
        {/*   <WishListMobile /> */}
      </div>

      {handleWhatComponentToShowHere()}

      <Footer></Footer>

      {/* <MailchimpSub /> */}
    </React.Fragment>
  );
}
